import Immutable from 'immutable';

const CourseEventRecord = Immutable.Record({
  sessionId: undefined,
  plannedPeriod: undefined,
  actualPeriod: undefined,
  sessionType: undefined,
  sessionTypeCode: undefined,
  isHighLight: undefined,
  isMostRecent: undefined,
  hasProgressTest: undefined,
  progressTestName: undefined,
});

class CourseEvent extends CourseEventRecord { }

const reviver = ([key, item]) => {
  if (! item) return [key, item];
  switch (key) {

    case 'actualPeriod':
    case 'plannedPeriod':
      return [key, {
        startDate: item.startDate,
        endDate: item.endDate,
      }];
    default:
      return [key, Immutable.fromJS(item)];
  }
};

CourseEvent.create = (data) => {
  const sessions = [];
  let groupId = '';
  let startWeekCode = '';
  let endWeekCode = '';
  let groupStartDate = '';
  let groupEndDate = '';
  let groupProgress = '';

  if (data) {
    groupId = data.groupId;
    startWeekCode = data.startWeekCode;
    endWeekCode = data.endWeekCode;
    groupStartDate = data.groupStartDate;
    groupEndDate = data.groupEndDate;
    groupProgress = data.groupProgress;

    data.sessions.map((SessionObject) => {
      sessions.push(new CourseEvent(SessionObject).mapEntries(reviver));
      return false;
    });
  }

  return {
    groupId,
    startWeekCode,
    endWeekCode,
    sessions,
    groupStartDate,
    groupEndDate,
    groupProgress,
  };
};

export default CourseEvent;



// WEBPACK FOOTER //
// ./data/CourseProgress/model.js